import React, { useEffect, useRef } from "react";
import "./Courses.css";

const COURSES = [
 
  {
    title: "Python / AI",
    image: "/images/python.png",
    mode: "Online/Offline",
    includes: "Projects, Chatbots, Deep Learning",
    buttonText: "Start Learning AI →",
  },
  {
    title: "Java Developer",
    image: "/images/java.png",
    mode: "Online/Offline",
    includes: "Projects, Spring Boot, API, Support",
    buttonText: "Become Real-World Pro →",
  },
  {
    title: "Web Development",
    image: "/images/web.png",
    mode: "Online/Offline",
    includes: "HTML, CSS, JS, React, Projects",
    buttonText: "Launch Your Dev Career →",
  }
  // {
  //   title: "Cyber Security",
  //   image: "/images/cyber.png",
  //   mode: "Online/Offline",
  //   includes: "Ethical Hacking, Threat Analysis",
  //   buttonText: "Secure Your Future →",
  // }
];
export default function Courses({ openEnroll }) {
  const callEnroll = openEnroll || (() => {});
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("fade-up");
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="courses-section animate-section">
      <div className="d-flex flex-column align-items-center">
        <h2 className="Main-title-heading">Courses we offer</h2>
      </div>

      <div className="course-grid">
        {COURSES.map((c, idx) => (
          <div className="course-card" key={idx}>
            <img src={c.image} alt={c.title} className="course-img" />

            <h3 className="course-title">{c.title}</h3>

            <ul className="course-details">
              <li>Mode: {c.mode}</li>
              <li>Includes: {c.includes}</li>
            </ul>

            <button
              type="button"
              className="course-btn"
              onClick={(e) => {
                e.preventDefault();
                callEnroll();
              }}
            >
              {c.buttonText}
            </button>
          </div>
        ))}
      </div>

      <p className="note">*on company demand…</p>
    </section>
  );
}